<rlst-modal [header]="data.title" (closeModal)="close()">
  <div class="content" [ngClass]="{'content_no-top-padding': isMobileNextStep}">
    <div class="mobile-back d-md-none d-flex justify-content-between" *ngIf="isMobileNextStep">
      <button class="btn btn-back p-0 w-auto" type="button" (click)="toggleMobileNextStep()">
        <i class="fa fa-angle-left" aria-hidden="true"></i>BACK
      </button>
    </div>
    <rlst-categories-list [categories]="categories"
                          [isMobileNextStep]="isMobileNextStep"
                          (categorySelection)="selectedCategoryFn($event)"
                          [selectedCategory]="selectedCategory"
                          headerTitle="Categories"
                          aggregateCategoryTitle="All Categories"></rlst-categories-list>
    <rlst-attributes-selection [attributes]="displayedAttributes"
                               [maxNumber]="maxNumberAttributesSelection"
                               [selectedNumber]="selectedAttributes.length"
                               [isMobileNextStep]="isMobileNextStep"
                               headerTitle="Attributes"
                               class="w-100 attributes-selection"
                               (attributeIsSelected)="selectAttribute($event)">
    </rlst-attributes-selection>
    <rlst-selected-properties (closeModal)="close()"
                              headerTitle="Selected Attributes"
                              nextStepButtonLabel="Select Attributes"
                              class="selected-options"
                              [ngClass]="{ 'd-flex': !isMobileNextStep }"
                              [selectedItems]="selectedAttributes"
                              [maxNumber]="maxNumberAttributesSelection"
                              (toggleMobileNextStep)="toggleMobileNextStep()"
                              (itemRemoved)="removeRegion($event)"
                              (clearSelection)="clearSelection()">
      <ng-template #selectedProperty let-item>
        <p class="current-item">{{ item.fieldName }}</p>
      </ng-template>
    </rlst-selected-properties>
  </div>
  <div mat-dialog-actions class="actions-panel d-flex">
    <div class="flex-spacer"></div>
    <button (click)="close()" class="btn-custom btn-custom-outline-blue-dark cancel-button">Cancel</button>
    <button class="btn-custom btn-custom-blue-dark" (click)="apply()" [disabled]="!selectedAttributes.length">Apply</button>
  </div>
</rlst-modal>
